import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-audio-skip-back-button',
  templateUrl: './audio-skip-back-button.component.html'
})
export class AudioSkipBackButtonComponent implements OnInit {  

  faUndoAlt = faUndoAlt;  

  @Input()
  disabled!: boolean

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) { }

  ngOnInit(): void {
  }

  skipBackwards() {
    // use effects to detect this, get current time, add 10 seconds and resubmit event
    this.store.dispatch(new actions.SkipBack());
  }
}
